export interface Plan {
  id: string;
  active: boolean;
  nickname: string;
  product: string;
}

export interface Price {
  id: string;
  active: boolean;
  created: number;
  currency: string;
  nickname: string;
  product: string;
  unitAmount: number;
  unitAmountDecimal: string;
}

export interface SubscriptionItem {
  id: string;
  created: number;
  plan: Plan;
  price: Price;
  quantity: number;
}

export interface SubscriptionItems {
  data: SubscriptionItem[];
  hasMore: boolean;
}

export interface Card {
  brand: string;
  expMonth: number;
  expYear: number;
  last4: string;
}

export interface PaymentMethod {
  id: string;
  card: Card;
  type: string;
  created: number;
}

export interface Invoice {
  id: string;
  created: number;
  hostedInvoiceUrl: string;
  paid: boolean;
  periodStart: number;
  periodEnd: number;
  status: string;
}

export interface MetadataMap {
  itunesId: string;
  showId: string;
}

export interface InvoiceSettings {
  defaultPaymentMethod: PaymentMethod;
}

export interface Customer {
  id: string;
  currency: string;
  delinquet: boolean;
  invoiceSettings: InvoiceSettings;
}

export enum SubscriptionStatus {
  incomplete = 'incomplete',
  incompleteExpired = 'incompleteExpired',
  trialing = 'trialing',
  active = 'active',
  pastDue = 'pastDue',
  canceled = 'canceled',
  unpaid = 'unpaid',
}

export interface Subscription {
  id: string;
  cancelAtPeriodEnd: boolean;
  currentPeriodStart: number;
  currentPeriodEnd: number;
  customer: Customer;
  defaultPaymentMethod: PaymentMethod;
  items: SubscriptionItems;
  latestInvoice: Invoice;
  metadata: MetadataMap[];
  status: SubscriptionStatus;
}
